import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';

const McmPackageCrossroadsGold: TenantPackageConfig<McmOrderContext> = {
  id: 'cr_gold',
  name: 'Crossroads Gold Drone',
  hideSavings: true,
  performables: [
    McmPhotoConfig,
    McmZillowConfig,
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.VIDEO_PHOTO,
        daytime: true,
      },
    },
  ],
  eligible: ({ buyer, parent }) => Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '40-50 Photos, Zillow 2D Floorplan + Zillow 3D, Drone Stills and Drone Video',
};

export default McmPackageCrossroadsGold;
